document.addEventListener('DOMContentLoaded', function() {
  // View toggle
  const viewButtons = document.querySelectorAll('.view-button');
  const portalContent = document.querySelector('.portal-content');

  viewButtons.forEach(button => {
    button.addEventListener('click', () => {
      viewButtons.forEach(b => b.classList.remove('active'));
      button.classList.add('active');
      
      const view = button.dataset.view;
      portalContent.className = `portal-content ${view}-view`;
    });
  });

  // Tab functionality
  const tabButtons = document.querySelectorAll('.tab-button');
  
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      tabButtons.forEach(b => b.classList.remove('active'));
      button.classList.add('active');
    });
  });
});